export default [
  {label: "@Actor", type: "text"},
  {label: "@Boundary", type: "text"},
  {label: "@Control", type: "text"},
  {label: "@Database", type: "text"},
  {label: "@Entity", type: "text"},
  {label: "@CloudWatch", type: "text"},
  {label: "@CloudFront", type: "text"},
  {label: "@Cognito", type: "text"},
  {label: "@DynamoDB", type: "text"},
  {label: "@EBS", type: "text"},
  {label: "@EC2", type: "text"},
  {label: "@ECS", type: "text"},
  {label: "@EFS", type: "text"},
  {label: "@ElastiCache", type: "text"},
  {label: "@ElasticBeantalk", type: "text"},
  {label: "@ElasticFileSystem", type: "text"},
  {label: "@Glacier", type: "text"},
  {label: "@IAM", type: "text"},
  {label: "@Kinesis", type: "text"},
  {label: "@Lambda", type: "text"},
  {label: "@LightSail", type: "text"},
  {label: "@RDS", type: "text"},
  {label: "@Redshift", type: "text"},
  {label: "@S3", type: "text"},
  {label: "@SNS", type: "text"},
  {label: "@SQS", type: "text"},
  {label: "@Sagemaker", type: "text"},
  {label: "@VPC", type: "text"},
  {label: "@AzureActiveDirectory", type: "text"},
  {label: "@AzureBackup", type: "text"},
  {label: "@AzureCDN", type: "text"},
  {label: "@AzureDataFactory", type: "text"},
  {label: "@AzureDevOps", type: "text"},
  {label: "@AzureFunction", type: "text"},
  {label: "@AzureSQL", type: "text"},
  {label: "@CosmosDB", type: "text"},
  {label: "@LogicApps", type: "text"},
  {label: "@VirtualMachine", type: "text"},
  {label: "@BigTable", type: "text"},
  {label: "@BigQuery", type: "text"},
  {label: "@CloudCDN", type: "text"},
  {label: "@CloudDNS", type: "text"},
  {label: "@CloudInterconnect", type: "text"},
  {label: "@CloudLoadBalancing", type: "text"},
  {label: "@CloudSQL", type: "text"},
  {label: "@CloudStorage", type: "text"},
  {label: "@DataLab", type: "text"},
  {label: "@DataProc", type: "text"},
  {label: "@GoogleIAM", type: "text"},
  {label: "@GoogleSecurity", type: "text"},
  {label: "@GoogleVPC", type: "text"},
  {label: "@PubSub", type: "text"},
  {label: "@SecurityScanner", type: "text"},
  {label: "@StackDriver", type: "text"},
  {label: "@VisionAPI", type: "text"},
  {label: '@return', type: 'keyword'}
]